define('GameDayCore/GDModel/ValueObjects/Gamecenter/GamecenterProbable',['require','exports','module','../ValueObjectFactory','extant/extant'],function(require, exports, module) {
	var VO = require('../ValueObjectFactory'),
        exists = require("extant/extant");

	VO.create(GamecenterProbable);

	function GamecenterProbable($data) {
		var vo = VO.ensureVO(this, GamecenterProbable),
			data = $data;

		vo.player_id = data.player_id || "";
		vo.useName = data.useName || "";
		vo.lastName = data.lastName || "";
		vo.rosterDisplayName = data.rosterDisplayName || "";
		vo.number = data.number || "";
		vo.throwinghand = data.throwinghand || "";
		vo.wins = data.wins || "";
		vo.losses = data.losses || "";
		vo.era = data.era || "";
		vo.so = data.so || "";
		vo.std_wins = data.std_wins || "";
		vo.std_losses = data.std_losses || "";
		vo.std_era = data.std_era || "";
		vo.std_so = data.std_so || "";
		vo.report = data.report || "";
		vo.video_id = (exists(data, "relatedvideo.media")) ? data.relatedvideo.media.conent_id : "";
		vo.video_title = (exists(data, "relatedvideo.title")) ? data.relatedvideo.title : "";
	}

	return GamecenterProbable;
});
